type Args = {
  doorType: string,
  netWidth: number,
  numberOfPanels: number,
  material: string,
  exactConfig: string,
  stilesAndRails: string,
  screenType?: string,
  swingPanelWidth?: string,
  swingPanelFraction?: string,
  sliderPocket?: string,
  handleStyle?: string,
  fullboundProfile?: string,
  addSixteenthToSliderPanel?: boolean
  isComboWindow?: boolean,
  isComboDoor?: boolean,
}

function calculatePanelWidth(panelArgs: Args) {
  const {
    doorType,
    netWidth,
    numberOfPanels,
    material,
    exactConfig,
    stilesAndRails,
  } = panelArgs;

  if (doorType === "Fixed Panel") {
    if(material === "All Aluminum"){
      if(exactConfig === "Direct Glaze"){
        return netWidth
      }else{
        if(panelArgs.fullboundProfile === "Window Profile"){
          return netWidth - 1.53125
        }else{
          return netWidth - 2.28125
        }
      }      
    }else if (exactConfig === "Fixed Bi-fold") {
      const jambLeg = material === "All Wood" ? 1.75 : 1.875;
      return netWidth - jambLeg;
    } 
    
    if (exactConfig === "Fixed Slider") {
      return netWidth - 1.75;
    }  
    
    if (exactConfig === "Fixed Full Bound") {
      return netWidth - 1.75;
    }
    
    if (exactConfig === "Fixed Inswing") {
      const jambLeg = material === "All Wood" ? 1.75 : 1.875;
      return netWidth - jambLeg;
    } 
    
    if (exactConfig === "Fixed Outswing") {
      return netWidth - 1.75;
    }
  } else if (doorType.includes("Bi-fold")) {
    if(material === "All Aluminum"){
      const centorSub = panelArgs.screenType?.includes("Centor") ? 2.3125 * 2 : 0;
      const netWidthAdjusted = netWidth - centorSub;
      return alumBifoldPanelWidth(netWidthAdjusted, numberOfPanels, exactConfig)
    }
    
    const extra = findPanelExtra(numberOfPanels);

    const isPico = stilesAndRails?.includes("Pico");

    const jambLeg =
      panelArgs.screenType?.includes("Centor") && isPico
        ? 10.5
        : panelArgs.screenType?.includes("Centor")
        ? 8
        : material === "All Wood"
        ? 1.75
        : 1.875;

    var allPanels = 0;

    // combo windows share a jamb leg with the bifold door
    if(panelArgs.isComboWindow){
        const gaps = (numberOfPanels - 1) * 0.125 + .1875;
        allPanels = netWidth - gaps
    }else if(panelArgs.isComboDoor){
      const gaps = (numberOfPanels - 1) * 0.125 + .1875 + .1875;
      allPanels = netWidth - jambLeg - gaps
    }else{
      const gaps = (numberOfPanels + 1) * 0.125 + extra;
      allPanels = netWidth - jambLeg - gaps
    }

    if (isPico) {
      return picoFormulas(allPanels, numberOfPanels, exactConfig);
    }

    return allPanels / numberOfPanels - 0.015;
  } else if (doorType === "Swing" || doorType === "Pivot") {
    if (!panelArgs.swingPanelWidth) return 0;

    let pw = parseInt(panelArgs.swingPanelWidth);

    let pwFraction = panelArgs.swingPanelFraction
      ? parseInt(panelArgs.swingPanelFraction.split("/")[0]) /
        parseInt(panelArgs.swingPanelFraction.split("/")[1])
      : 0;

    return pw + pwFraction;
  } else if (doorType === "Slider") {
    var stiles =
      stilesAndRails === "Euro | Contemporary"
        ? 3.4375
        : stilesAndRails === "Slimline" ||
          stilesAndRails === "Slimline Traditional"
        ? 2.5
        : stilesAndRails === 'Bottom rail 7"' ||
          stilesAndRails === 'Bottom rail 4-3/4"'
        ? 4.75
        : 0;

    var panels = exactConfig.replace(/[^X^A^O]/g, "").length;

    const doubleSided = exactConfig.includes("-");

    let stileMultiply = doubleSided
      ? (exactConfig.split("-")[0].replace(/[^X^A^O]/g, "").length - 1) * 2
      : panels - 1;

    if (panelArgs.sliderPocket === "With Pocket") {
      const jambLeg =
        panelArgs.screenType?.includes("Centor") && !doubleSided ? 3.125 : 0;

      if (
        exactConfig === "PX" ||
        exactConfig === "XP" ||
        exactConfig === "PX-AP" ||
        exactConfig === "PA-XP"
      ) {
       return !doubleSided
          ? netWidth - jambLeg - 0.875 - 0.1875 + 1.125
          : (netWidth - jambLeg - 0.1875 + 2.25) / 2;
      } else {
        const isDoubleWood = doubleSided && material === "All Wood";

        let pwAdder = isDoubleWood
          ? netWidth + 1.4375 + 0.1875
          : doubleSided && !isDoubleWood
          ? netWidth + 1.4375
          : netWidth - 0.25;

        let panelWidth = (pwAdder - jambLeg + stiles * stileMultiply) / panels;

        if (!panelArgs.addSixteenthToSliderPanel) {
          //subtract 1/16 from panel width per antonio 05/27/25
          panelWidth -= 0.0625;
        }

        return panelWidth
      }
    } else {
      const jambLeg = panelArgs.screenType?.includes("Centor") ? 6.25 : 0;

      let pwAdder = 0;
      if (exactConfig.includes("Primary")) {
        pwAdder = 2.125;
      } else {
        const singleDoor = ["XO", "OX", "OA-XO", "OX-AO"];

        if (
          singleDoor.includes(exactConfig) &&
          panelArgs.handleStyle !== "One Piece Truth (Flush Mount)"
        ) {
          //all wood used to be 1.75 for double sided, 05/16 2025 added .1875
          pwAdder = 1.9375;
        } else if (!doubleSided) {
          pwAdder = 2.4375;
        } else if (doubleSided) {
          //all wood used to be 2.75 for double sided, 05/16 2025 added .1875
          pwAdder = 2.9375;
        }
      }

      let panelWidth =
        (netWidth - jambLeg - pwAdder + stiles * stileMultiply) / panels;

      if (!panelArgs.addSixteenthToSliderPanel) {
        //subtract 1/16 from panel width per antonio 05/27/25
        panelWidth -= 0.0625;
      }

      return panelWidth
    }
  }

  return 0;
}

function findPanelExtra(panels: number) {
  if ([1, 2, 3].includes(panels)) {
    return 0.125;
  } else if ([4, 5].includes(panels)) {
    return 0.1875;
  } else {
    return 0.25;
  }
}

export const alumBifoldPanelWidth = (netWidth: number, numPanels: number, config: string) => {
  function perPanelWidth(width: number) {
    return (width - numPanels * .4724) / numPanels;
  } 

  const ADJUSTABLE_JAMB = 2.6378

  if (config === "2L" || config === "2R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB)
  }

  if (config === "3L" || config === "3R") {
    return perPanelWidth(netWidth - 2.0669 - ADJUSTABLE_JAMB);
  }

  if (config === "4L" || config === "4R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB);
  }

  if (config === "5L" || config === "5R") {
    return perPanelWidth(netWidth - 2.0669 - ADJUSTABLE_JAMB);
  }

  if (config === "6L" || config === "6R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB);
  }

  if (config === "7L" || config === "7R") {
    return perPanelWidth(netWidth - 2.0669 - ADJUSTABLE_JAMB);
  }

  if (config === "1L2R" || config === "2L1R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "1L3R" || config === "3L1R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "1L4R" || config === "4L1R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "1L5R" || config === "5L1R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "1L6R" || config === "6L1R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "1L7R" || config === "7L1R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.7323);
  }

  if (config === "2L3R" || config === "3L2R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "2L4R" || config === "4L2R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.7323);
  }

  if (config === "2L5R" || config === "5L2R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "2L6R" || config === "6L2R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.7323);
  }

  if (config === "3L4R" || config === "4L3R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "3L5R" || config === "5L3R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "2L2R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.7323);
  }

  if (config === "3L3R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.4173);
  }

  if (config === "4L4R") {
    return perPanelWidth(netWidth - 2 * ADJUSTABLE_JAMB - 1.7323);
  }

  return 0;
};

export const picoFormulas = (allPanels: number, numPanels: number, config: string) => {
  function perPanelWidth(width: number) {
    return width / numPanels - 0.015;
  }

  if (config === "1L" || config === "1R") {
    return perPanelWidth(allPanels);
  }

  if (config === "2L" || config === "2R") {
    return perPanelWidth(allPanels);
  }

  const PICO_ADD = 0.472441;

  if (config === "3L" || config === "3R") {
    return perPanelWidth(allPanels - PICO_ADD);
  }

  if (config === "4L" || config === "4R") {
    return perPanelWidth(allPanels - 2 * PICO_ADD);
  }

  if (config === "5L" || config === "5R") {
    return perPanelWidth(allPanels - PICO_ADD);
  }

  if (config === "6L" || config === "6R") {
    return perPanelWidth(allPanels - 2 * PICO_ADD);
  }

  if (config === "7L" || config === "7R") {
    return perPanelWidth(allPanels - PICO_ADD);
  }

  if (config === "8L" || config === "8R") {
    return perPanelWidth(allPanels - 2 * PICO_ADD);
  }

  if (config === "1L2R" || config === "2L1R") {
    return perPanelWidth(allPanels);
  }

  if (config === "1L3R" || config === "3L1R") {
    return perPanelWidth(allPanels - PICO_ADD);
  }

  if (config === "1L4R" || config === "4L1R") {
    return perPanelWidth(allPanels - 2 * PICO_ADD);
  }

  if (config === "1L5R" || config === "5L1R") {
    return perPanelWidth(allPanels - PICO_ADD);
  }

  if (config === "1L6R" || config === "6L1R") {
    return perPanelWidth(allPanels - 2 * PICO_ADD);
  }

  if (config === "1L7R" || config === "7L1R") {
    return perPanelWidth(allPanels - PICO_ADD);
  }

  if (config === "2L3R" || config === "3L2R") {
    return perPanelWidth(allPanels - PICO_ADD);
  }

  if (config === "2L4R" || config === "4L2R") {
    return perPanelWidth(allPanels - 2 * PICO_ADD);
  }

  if (config === "2L5R" || config === "5L2R") {
    return perPanelWidth(allPanels - PICO_ADD);
  }

  if (config === "2L6R" || config === "6L2R") {
    return perPanelWidth(allPanels - 2 * PICO_ADD);
  }

  if (config === "3L4R" || config === "4L3R") {
    return perPanelWidth(allPanels - 3 * PICO_ADD);
  }

  if (config === "3L5R" || config === "5L3R") {
    return perPanelWidth(allPanels - 2 * PICO_ADD);
  }

  if (config === "2L2R") {
    return perPanelWidth(allPanels);
  }

  if (config === "3L3R") {
    return perPanelWidth(allPanels - 2 * PICO_ADD);
  }

  if (config === "4L4R") {
    return perPanelWidth(allPanels - 4 * PICO_ADD);
  }

  return 0;
};

export { calculatePanelWidth, findPanelExtra };
